module.exports = __webpack_public_path__ + "static/media/Ropeze-SS-Folding-Cleat-closed.46af9a1a.jpg";